import React from "react";
import { Box } from "@mui/material";
import colors from "../../../shared/themes/colors";
import useTranslation from "../../../shared/hooks/useTranslation";
import { ServiceRequest } from "../models/models";
import { useServiceRequestFormatters } from "../hooks/useServiceRequestFormatters";
import ViewServiceRequestSectionCard from "./ViewServiceRequestSectionCard";

export interface ViewServiceRequestCommercialTermsCardProps {
  serviceRequest: ServiceRequest;
}

const ViewServiceRequestCommercialTermsCard = ({ serviceRequest }: ViewServiceRequestCommercialTermsCardProps) => {
  const { translate } = useTranslation(["servicing", "common"]);

  const {
    formatServiceDate,
    formatWorkingHours,
    formatWeekendWork,
    formatBudget,
    formatPaymentTerms
  } = useServiceRequestFormatters();

  const terms = [
    { label: "servicing:serviceDate", value: formatServiceDate(serviceRequest) },
    { label: "servicing:workingHours", value: formatWorkingHours(serviceRequest) },
    { label: "servicing:weekendWork", value: formatWeekendWork(serviceRequest) },
    { label: "servicing:desiredBudget", value: formatBudget(serviceRequest) },
    { label: "servicing:paymentTerms", value: formatPaymentTerms(serviceRequest) },
  ];

  return (
    <ViewServiceRequestSectionCard>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Box className="text-18-bold" color={colors.secondary.gray20}>
          {translate("servicing:commercialTermsAndConditions")}
        </Box>

        <Box
          sx={{
            background: colors.secondary.gray98,
            borderRadius: "8px",
            display: "flex",
            gap: 3,
            p: 2
          }}
        >
          {terms?.map((termsItem) => (
            <Box key={termsItem.label} sx={{ flex: 1 }}>
              <Box className="text-12-regular" color={colors.secondary.gray40}>
                {translate(termsItem.label)}
              </Box>

              <Box className="text-14-medium" color={colors.secondary.gray20}>
                {termsItem.value}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </ViewServiceRequestSectionCard>
  );
};

export default ViewServiceRequestCommercialTermsCard;